import * as React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { CloudUpload } from "@mui/icons-material";

interface DropzoneProps {
  onAddFiles: (files: File[]) => void;
  accept?: string;
  multiple?: boolean;
  title?: string;
  subtitle?: string;
  buttonLabel?: string;
}

export default function Dropzone({
  onAddFiles,
  accept = "*",
  multiple = true,
  title = "Arraste e solte arquivos",
  subtitle = "ou clique para selecionar",
  buttonLabel = "Selecionar arquivos",
}: DropzoneProps) {
  const theme = useTheme();
  const [dragActive, setDragActive] = React.useState(false);

  const inputRef = React.useRef<HTMLInputElement | null>(null);

  const addFiles = (list: FileList | File[]) => {
    const files = Array.isArray(list) ? list : Array.from(list);
    if (!files.length) return;
    onAddFiles(files);
  };

  return (
    <Box
      onDragOver={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onDragEnter={() => setDragActive(true)}
      onDragLeave={() => setDragActive(false)}
      onDrop={(e) => {
        e.preventDefault();
        addFiles(e.dataTransfer.files);
        setDragActive(false);
      }}
      onClick={() => inputRef.current?.click()}
      sx={{
        p: 3,
        border: "2px dashed",
        borderColor: dragActive ? theme.palette.primary.main : theme.palette.divider,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: theme.palette.primary.main,
        cursor: "pointer",
        bgcolor: dragActive ? theme.palette.background.default : theme.palette.background.paper,
        "&:hover": { borderColor: theme.palette.primary.main },
      }}
    >
      <CloudUpload sx={{ fontSize: 40, color: theme.palette.primary.main, mb: 1 }} />
      <Typography sx={{ fontWeight: 600 }}>{title}</Typography>
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
        {subtitle}
      </Typography>
      <Button variant="contained" color="primary" sx={{ textTransform: "none", fontWeight: 600 }}>
        {buttonLabel}
      </Button>
      <input
        ref={inputRef}
        type="file"
        multiple={multiple}
        accept={accept}
        style={{ display: "none" }}
        onChange={(e) => {
          if (e.target.files) addFiles(e.target.files);
        }}
      />
    </Box>
  );
}